<div class="heading">
  <div class="i-acc i-acc--{{ tariff.type }}"></div>
  <span data-title="tariff">{{ tariff.name }}</span>
</div>
<div class="description">
  @switch (!tariff.availability || !tariff.availability.reason) {
    @case (true) {
      <span>{{ tariff.comment }}</span>
    }
    @default {
      <span class="not-accessible">{{ tariff.availability.reason }}</span>
    }
  }
</div>
<button
  (click)="selectTariff.emit()"
  [attr.data-e2e-element]="'acc-types.card.tariff.' + tariff.type.toLowerCase()"
  [class]="'button ' + tariff.type"
  [disabled]="tariff.availability && !tariff.availability.isAvailable"
  type="button"
  translate="register-account.label.open-account"
></button>
